import { useTranslation } from 'next-i18next';
import appConfig from 'app-config';
import AzarAppIcon from 'src/assets/images/imgAzarSymbolBackground.svg';
interface Props {
  className?: string;
}
export default function AppIcon({
  className
}: Props) {
  const {
    t
  } = useTranslation();
  switch (appConfig.serviceCode) {
    case 'vividi':
      return <img src='/vividi/images/icon-128x128.png' alt={t('OG_TITLE')} className={className} />;
    case 'azar':
    default:
      return <AzarAppIcon className={className} />;
  }
}